module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/03-95921fedc4869474733145b79c2129e3.jpg";